import { z } from 'zod';

import { zNonEmptyString, zOptionalString } from './common';

/**
 * Способы выплаты человеку.
 *
 * Одного поля под криптокошелёк не хватает: у человека бывает карта и
 * кошелёк, а у крипты ещё и сеть. TRC20 и ERC20 — разные адреса, и перевод
 * не в ту сеть означает потерянные деньги без возврата. Поэтому сеть
 * хранится рядом с адресом, а не в памяти менеджера и не в переписке.
 */

export const PAYMENT_METHOD_KINDS = ['CARD', 'CRYPTO', 'BANK', 'EWALLET', 'OTHER'] as const;
export type PaymentMethodKind = (typeof PAYMENT_METHOD_KINDS)[number];

/** Сети, в которых чаще всего ошибаются. Список открытый: можно вписать своё. */
export const COMMON_CRYPTO_NETWORKS = ['TRC20', 'ERC20', 'BEP20', 'TON', 'SOL', 'BTC'] as const;

export const createPaymentMethodSchema = z.object({
  kind: z.enum(PAYMENT_METHOD_KINDS),
  /** Как называть в списке: «Тинькофф», «Основной USDT». */
  label: zNonEmptyString(60),
  /** Номер карты, адрес кошелька, реквизиты счёта. */
  details: zNonEmptyString(200),
  /** Сеть криптоадреса. Для карты и счёта не заполняется. */
  network: zOptionalString(20),
  isPrimary: z.boolean().default(false),
  note: zOptionalString(200),
});
export type CreatePaymentMethodInput = z.infer<typeof createPaymentMethodSchema>;

export const updatePaymentMethodSchema = createPaymentMethodSchema.partial();
export type UpdatePaymentMethodInput = z.infer<typeof updatePaymentMethodSchema>;

export interface PaymentMethodDto {
  id: string;
  personId: string;
  kind: PaymentMethodKind;
  label: string;
  details: string;
  network: string | null;
  isPrimary: boolean;
  note: string | null;
  createdAt: string;
}
